import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
// import { TanStackDevtools } from "@tanstack/react-devtools";
// import { formDevtoolsPlugin } from "@tanstack/react-form-devtools";
// import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";
// import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";

import "./sentry/config";

// biome-ignore lint/style/noNonNullAssertion: according to docs
ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<App />
		{/* TODO figure out how to setup devtools */}
		{/* <TanStackDevtools
			plugins={[
				formDevtoolsPlugin(),
				{
					name: "TanStack Query",
					render: <ReactQueryDevtoolsPanel />,
				},
				{
					name: "TanStack Router",
					render: <TanStackRouterDevtoolsPanel />,
				},
			]}
		/> */}
	</React.StrictMode>,
);
